import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'
import {
  LinkOnlyRedemptionBlockFragment,
  MultipleCodesRedemptionBlockFragment,
  Redemption,
  SingleCodeRedemptionBlockFragment,
} from '../../redemptions'

export const OfferGridBlockFragment: BlockFragment = {
  name: 'offerGrid',
  fragment: gql`
    fragment offerGrid on OfferGrid {
      id
      blockName
      blockType
      offerGridHeading: heading
      offerGridLimit: limit
      offerGridOffers: offers {
        id
        name
        category {
          name
          slug
        }
        featuredImage {
          url
          alt
        }
        brand {
          id
          slug
        }
        slug
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on OfferGrid {
      id
      blockName
      blockType
      offerGridHeading: heading
      offerGridLimit: limit
      offerGridOffers: offers {
        id
        name
        category {
          name
          slug
        }
        featuredImage {
          url
          alt
        }
        brand {
          id
          slug
        }
        slug
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const OfferGridBlockType = 'offerGrid'

export interface OfferGridBlock extends BaseOfferBlock {
  blockType: typeof OfferGridBlockType
  offerGridHeading: string
  offerGridLimit: number
  iamgePriority?: boolean
  offerGridOffers: {
    id: string
    name: string
    category: {
      name: string
      slug: string
    }
    featuredImage: {
      url: string
      alt: string
    }
    brand: {
      slug: string
    }
    slug: string
    offerLinkLabel?: string
    redeemInList: boolean
    canRedeem: boolean
    redemptions: Redemption[]
    isBookmarked: boolean
  }[]
}
